import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

/* import AmplifyUIAngularModule  */
import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';
import { Amplify } from 'aws-amplify';
import awsconfig from '../aws-exports';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

// ANGULAR MATERIAL
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatRadioModule, MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

// COMPONENTES
import { AppComponent } from './app.component';
import { PaginaMainMasterComponent } from './paginas/pagina-main-master/pagina-main-master.component';
import { TabDatosComponent } from './tabs/tab-datos/tab-datos.component';
import { TabEventosComponent } from './tabs/tab-eventos/tab-eventos.component';
import { TabAlarmasComponent } from './tabs/tab-alarmas/tab-alarmas.component';
import { PaginaMainUserComponent } from './paginas/pagina-main-user/pagina-main-user.component';
import { PaginaWelcomeComponent } from './paginas/pagina-welcome/pagina-welcome.component';
import { PaginaMainCareComponent } from './paginas/pagina-main-care/pagina-main-care.component';
import { GraficaLineComponent } from './components/grafica-line/grafica-line.component';
import { GraficaBarComponent } from './components/grafica-bar/grafica-bar.component';
import { GraficaBarNewComponent } from './components/grafica-bar-new/grafica-bar-new.component';
import { AlarmaComponent } from './components/alarma/alarma.component';
import { SelectorComponent } from './components/Selector/selector.component';
import { PaginaLoginAwsComponent } from './paginas/pagina-login-aws/pagina-login-aws.component';
import { TabActualComponent } from './tabs/tab-actual/tab-actual.component';
import { RegistroAlarmasComponent } from './components/registro-alarmas/registro-alarmas.component';

import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';

import { KeycloakService } from 'keycloak-angular';


/* Configure Amplify resources */
Amplify.configure(awsconfig);

@NgModule({
  declarations: [
    AppComponent,
    PaginaMainUserComponent,
    PaginaMainCareComponent,
    PaginaWelcomeComponent,
    PaginaLoginAwsComponent,
    TabDatosComponent,
    TabEventosComponent,
    TabAlarmasComponent,
    GraficaLineComponent,
    GraficaBarComponent,
    GraficaBarNewComponent,
    AlarmaComponent,
    SelectorComponent,
    TabActualComponent,
    PaginaMainMasterComponent,
    RegistroAlarmasComponent
    
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CommonModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatRadioModule,
    MatTabsModule,
    MatIconModule,
    MatSliderModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatButtonModule, 
    MatNativeDateModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatSliderModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    // MatFormFieldControl,
    // MatFormField
    NgxMaterialTimepickerModule,
    AmplifyUIAngularModule
    
  ],
  providers: [ 
    { provide: MAT_DATE_LOCALE, useValue: "es-sv" },
    KeycloakService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
